export default __webpack_public_path__ + "static/media/BUDGETING.01fc8ad6.svg";